const fullWidth = `left-0 w-full`;
export const fullHeight = `top-0 h-full`;
const expand = `${fullWidth} ${fullHeight}`;

export const fullCover = `absolute ${expand}`;
export const fullCoverFixed = `fixed ${expand}`;
export const topAlign = `absolute top-0 ${fullWidth}`;
export const leftAlign = `absolute left-0`;
export const rightAlign = `absolute right-0`;
export const topLeftAlign = `absolute top-0 left-0`;
export const topRightAlign = `absolute top-0 right-0`;
export const bottomAlign = `absolute bottom-0 ${fullWidth}`;
export const bottomLeftAlign = `absolute bottom-0 left-0`;
export const bottomRightAlign = `absolute bottom-0 right-0`;
export const bottomAlignFixed = `fixed bottom-0 ${fullWidth}`;
export const allCentered = `absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2`;
export const verCentered = `absolute top-1/2 -translate-y-1/2`;
export const allCenteredChild = `flex justify-center items-center`;
export const verCenteredChild = `flex items-center`;
export const horCenteredChild = `flex justify-center`;
export const horFlexEndChild = `flex justify-end`;
export const wrappedChild = `flex flex-wrap`;
export const bgGraphics = `bg-cover bg-no-repeat Bgp(c_t)`;
export const bgRepeat = `bg-auto bg-repeat`;
export const ellipsize = "whitespace-nowrap overflow-x-hidden text-ellipsis max-w-full";
export const breakWord = `break-words break-words whitespace-pre-wrap`;
export const noFlexGrow = `grow-0 shrink-0 basis-auto`;
export const horCentered = `absolute top-0 left-1/2 -translate-x-1/2`;
export const hr = `border-2 border-[#12101a] m-0`;
